import Navigator from 'app';
import VoteModel from './vote_model';
const VoteCollection = Backbone.Collection.extend({
  model: VoteModel,
  initialize: function (date) {
    this.url = Navigator.config.api_base + "votes/on_date/" + date;
  }
});
const API = {
  getVotesForDate: function getVotesForDate(date) {
    var d = $.Deferred();
    var votes = new VoteCollection(date);
    votes.fetch({
      dataType: "json",
      success: function (data) {
        d.resolve(data);
      }
    });
    return d.promise();
  }
};
Navigator.reqres.setHandler("vote:daily", function (date) {
  return API.getVotesForDate(date);
});
export default VoteCollection;